import { render, staticRenderFns } from "./PatientVisitLayout.vue?vue&type=template&id=68760352&scoped=true"
import script from "./PatientVisitLayout.vue?vue&type=script&lang=js"
export * from "./PatientVisitLayout.vue?vue&type=script&lang=js"
import style0 from "./PatientVisitLayout.vue?vue&type=style&index=0&id=68760352&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68760352",
  null
  
)

export default component.exports